import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
export default function DialogObservacaoPedidos({
    open,
    handleClose,
    pedidos
}: DialogObservacaoPedidosProps) {
    return (
        <Dialog
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Observações</DialogTitle>
            <DialogContent>
                {
                    pedidos.map(item => (
                        <Typography key={item.codigo}><b>Pedido #{item.codigo}:</b> {item.observacao}</Typography>
                    ))
                }
            </DialogContent>
            <DialogActions>
                <Button
                    startIcon={<VisibilityOffIcon/>}
                    onClick={handleClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogObservacaoPedidosProps {
    open: boolean;
    handleClose: () => void
    pedidos: {
        codigo: string;
        observacao: string;
    }[]
}